import { useMemo } from 'react';

export function usePrintView() {
    const pathName = useMemo(() => window.location.pathname, [window.location.pathname]);

    return useMemo(() => pathName.includes('print-view'), [pathName]);
}
